import { TILIA_WIDGET_URL, isFrontend } from '@config'
import { TILIA_WIDGET } from '@config/htmlIDs.js'
import { useTheming } from '@composables'

let widgetLoaded = false

/**
 * Initialize the Tilia widget with the required flow.
 */
export function initTiliaWidget({
  flow,
  redirect,
  callback,
  transactionAmount,
  payoutType = 'USD',
  verificationLevel = 'basic_pii',
  hideExit = true,
}) {
  function onLoad() {
    const { themeVars } = useTheming()
    window.Tilia.execute({
      rootId: TILIA_WIDGET,
      flow: flow,
      redirect: {
        url: redirect,
      },
      onComplete: callback,
      fullWidth: true,
      resize: true,
      theme: {
        backgroundColor:
          themeVars.value[isFrontend ? '--dark' : '--modal-background'],
        primaryColor:
          themeVars.value[isFrontend ? '--primary' : '--primary-button-color'],
      },
      flowConfig: {
        transactionDetails: {
          transaction_amount: transactionAmount,
        },
        verificationLevel,
        currency: payoutType,
        hideExitButtons: hideExit,
        hideWalletBalance: false,
      },
    })
    widgetLoaded = true
  }

  if (widgetLoaded) {
    onLoad()
  } else {
    const widget = document.createElement('script')
    widget.src = TILIA_WIDGET_URL
    widget.onload = onLoad
    document.body.appendChild(widget)
  }
}
